import { BalanceText, IconButton, Shadow, Text, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

import {
  TableContentItemBadge,
  TableContentItemCaptions,
} from '../../../../../../components/TableContent';
import { mapCaptions } from '../../../../utils';
import { ItemTag } from '../../../Customer/components/ItemTag';

import { AddedCustomerItemResponsiveProps } from '.';

export const AddedCustomerItemMobile: React.FC<AddedCustomerItemResponsiveProps> = ({
  item,
  handleRemoveCustomerToCart,
  handleUpdateBalance,
  isLoadingBalance,
}) => {
  return (
    <Shadow borderRadius={BoxRadius.xs} level={2}>
      <VStack p={Spacing['inline.xxs']} space={Spacing['inline.xxxs']} borderRadius={BoxRadius.xs}>
        <HStack justifyContent="space-between">
          <VStack>
            <Text fontSize={Typography['fontsize.md']} variant="semibold" color="neutral.darkest">
              {item.name}
            </Text>
            <HStack space={Spacing['inline.nano']} alignItems="center">
              <Text fontSize={Typography['fontsize.xs']} color="neutral.dark">
                Conta
              </Text>
              <Text fontSize={Typography['fontsize.xs']} color="neutral.dark">
                {item.accountNumber}
              </Text>
            </HStack>
          </VStack>
          <HStack space={Spacing['inline.quarck']}>
            <TableContentItemCaptions icons={mapCaptions(item)} />
            <TableContentItemBadge>{item.suitabilityProfileName!}</TableContentItemBadge>
          </HStack>
        </HStack>
        <HStack alignItems="center" justifyContent="space-between">
          <Text fontSize={Typography['fontsize.md']} variant="regular" color="neutral.black">
            Hashtag
          </Text>
          <ItemTag isListing data={item.tags} itemId={item.customerId} />
        </HStack>
        <HStack space={Spacing['stack.xxxs']} alignItems="center" justifyContent="space-between">
          <VStack space={Spacing['stack.quarck']}>
            <Text fontSize={Typography['fontsize.xs']} color="neutral.medium">
              Saldo disponível
            </Text>
            <BalanceText
              balance={item.availableBalance}
              lastUpdatedAt={new Date()}
              hasUpdateButton
              isUpdating={isLoadingBalance}
              onUpdateButtonPress={handleUpdateBalance}
              textAlign="start"
              positiveBalanceColor="neutral.black"
              negativeBalanceColor="feedback.error.default"
            />
          </VStack>
          <IconButton
            testId="icon-button"
            onPress={handleRemoveCustomerToCart}
            icon="Trash"
            p={0}
            iconColor={Color['feedback.error.default']}
            iconSize="sm"
          />
        </HStack>
      </VStack>
    </Shadow>
  );
};
